$(document).ready(function() {
  let $body = $('body');
  /*if (window.theme_data.locale === 'fr') {
   setTimeout(function() {

   setInterval(function() {
   $body.find('.scr-open-size-chart').html('Guide des tailles');

   let $reviews_title = $body.find('.jdgm-rev-widg__title');
   if ($reviews_title.length) {
   $reviews_title.text('Avis des clients');
   }
   let $reviews_summary_text = $body.find('.jdgm-rev-widg__summary-text');
   if ($reviews_summary_text.length) {
   let reviews_summary_text   = $reviews_summary_text.text().trim();
   let reviews_summary_number = reviews_summary_text.match(/-?\d+(\.\d+)?/g);
   reviews_summary_number     = reviews_summary_number.join('');
   reviews_summary_number     = reviews_summary_number.trim();
   if (reviews_summary_number === '') {
   $reviews_summary_text.text('Soyez le premier à rédiger un avis');
   } else {
   $reviews_summary_text.text('Basée sur ' + reviews_summary_number + ' avis');
   }
   }
   let $reviews_write_review_btn = $body.find('.jdgm-write-rev-link');
   if ($reviews_write_review_btn.length) {
   $reviews_write_review_btn.text('Écrire une évaluation');
   }
   let $reviews_badges = $body.find('.jdgm-rev__buyer-badge');
   if ($reviews_badges.length) {
   $reviews_badges.each(function() {
   let beforeStyle = window.getComputedStyle(this, ':before');
   let beforeContent = beforeStyle.getPropertyValue('content');
   console.log(beforeContent.trim().toLowerCase())
   if(beforeContent.trim().toLowerCase() === '"verified"'){
   $(this).addClass('review-badge-verified-french');
   }
   });

   }
   let $reviews_dropdown = $body.find('.jdgm-sort-dropdown');
   if ($reviews_dropdown.length) {
   $reviews_dropdown.find('option').each(function() {
   let option_text  = $(this).text().toLowerCase().trim();
   let replace_text = $(this).text();
   switch (option_text) {
   case 'most recent':
   replace_text = 'Le plus récent';
   break;
   case 'highest rating':
   replace_text = 'La plus élevée';
   break;
   case 'lowest rating':
   replace_text = 'La plus base';
   break;
   case 'only pictures':
   replace_text = 'Seulement des photos';
   break;
   case 'pictures first':
   replace_text = 'Photos d’abord';
   break;
   case 'videos first':
   replace_text = 'Vidéos D\'abord';
   break;
   case 'most helpful':
   replace_text = 'Le plus utile';
   break;
   }
   $(this).text(replace_text);
   });
   }

   }, 200);
   }, 500);
   } */
  /*$body.on('click', '#Subscribe-footer', function(e) {
   e.preventDefault();
   $body.find('#footer-success-message').remove();
   let $button = $(this);
   $button.attr('disabled', 'disabled');
   $body.find('#footer-subscribe-email').removeClass('border-danger');
   if (!validateEmail($body.find('#footer-subscribe-email').val().trim())) {
   $body.find('#footer-subscribe-email').addClass('border-danger');
   $button.each(function() {
   this.removeAttribute('disabled');
   });
   return;
   }
   $.ajax({
   url:      'https://app.everydaysunday.com/api/customers',
   method:   'POST',
   data:     {
   action: 'subscribing',
   email:  $body.find('#footer-subscribe-email').val().trim(),
   lang:   window.theme_data.locale,
   source: 'footer',
   id:     window.theme_data.customer_id,
   },
   dataType: 'json',
   success:  function(response_data) {
   $button.each(function() {
   this.removeAttribute('disabled');
   });

   if (response_data.success) {
   let success_html = '<div style="padding-bottom:10px;" id="footer-success-message">Your email has been added successfully</div>';
   $button.closest('form').prepend(success_html);
   setTimeout(function() {
   $body.find('#footer-success-message').remove();
   }, 5000);
   // new Swal({
   //            title: '',
   //            text:  '',
   //            icon:  'success',
   //          }).then(function() {
   // });
   } else {
   $body.find('#footer-subscribe-email').
   addClass('border-danger');
   }
   },
   error:    function(response_data) {
   $button.each(function() {
   this.removeAttribute('disabled');
   });
   console.log(response_data);
   new Swal({
   title: 'Error',
   text:  'Something went wrong!',
   icon:  'error',
   });
   },
   });
   });*/

  /*$body.on('submit', '#newsletter-subscribe', function(e) {
   e.preventDefault();
   $body.find('#hp-subscribe-success-message').remove();
   let $button = $(this).find('button');
   $button.attr('disabled', 'disabled');
   $body.find('#newsletter-subscribe-email').removeClass('border-danger');
   if (!validateEmail($body.find('#newsletter-subscribe-email').val().trim())) {
   $body.find('#newsletter-subscribe-email').addClass('border-danger');
   $button.each(function() {
   this.removeAttribute('disabled');
   });
   return;
   }

   $.ajax({
   url:      'https://app.everydaysunday.com/api/customers',
   method:   'POST',
   data:     {
   action: 'subscribing',
   email:  $body.find('#newsletter-subscribe-email').val().trim(),
   lang:   window.theme_data.locale,
   source: 'homepage',
   id:     window.theme_data.customer_id,
   },
   dataType: 'json',
   success:  function(response_data) {
   $button.each(function() {
   this.removeAttribute('disabled');
   });

   if (response_data.success) {
   let success_html = '<div style="padding-bottom:10px;" id="hp-subscribe-success-message">Your email has been added successfully</div>';
   $button.closest('form').prepend(success_html);
   setTimeout(function() {
   $body.find('#hp-subscribe-success-message').remove();
   }, 5000);
   } else {
   $body.find('#newsletter-subscribe-email').addClass('border-danger');
   }
   },
   error:    function(response_data) {
   $button.each(function() {
   this.removeAttribute('disabled');
   });
   console.log(response_data);
   new Swal({
   title: 'Error',
   text:  'Something went wrong!',
   icon:  'error',
   });
   },
   });
   });*/

  $body.on('click', '.marketing-radio', function() {
    let target = $(this).attr('data-target');
    if ($(this).attr('data-type') === 'radio' && !$(this).hasClass('selected')) {
      let name = $(this).attr('data-name');
      $body.find('div[data-name="' + name + '"]').removeClass('selected');
      $body.find(target)[0].checked = true;
      $(this).addClass('selected');
    } else if ($(this).attr('data-type') !== 'radio') {
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');

      } else {
        $(this).addClass('selected');
      }
      $body.find(target)[0].checked = !$body.find(target)[0].checked;
      console.log($body.find(target));
      console.log($body.find(target)[0].checked);
      $body.find(target).trigger('change');
    }
  });
  $body.on('click', '.marketing-label', function() {
    $(this).closest('.marketing-radio-container').find('.marketing-radio')[0].click();
  });
  /*wishlist*/
  if (!window.theme_data.customer_logged_in) {
    let wishlist_url = '';
    if (window.theme_data.locale === 'fr') {
      wishlist_url += '/fr';
    }
    wishlist_url += '/account/login?return=' +
                    encodeURIComponent(window.location.href);
    setTimeout(function() {
      $body.find('.wishlist-item').find('a').attr('href', wishlist_url);
    }, 500);
  }

  $body.on('click', '.wishlist-item', function(e) {
    if (window.theme_data.customer_logged_in) {
      e.preventDefault();

      let $this = $(this);

      let product_id  = $(this).attr('data-product-id');
      let product_url = $(this).
          find('.product-link').
          attr('data-href');
      console.log('product_url');
      console.log(product_url);
      product_url     = product_url.split('/fr/').join('/');
      let sku         = $(this).attr('data-sku');
      $.ajax({
               url:     'https://app.everydaysunday.com/api/wishlist',
               method:  'POST',
               data:    {
                 email:       window.theme_data.customer_email,
                 first_name:  window.theme_data.customer_first_name,
                 last_name:   window.theme_data.customer_last_name,
                 action:      'add-remove-wishlist',
                 product_id:  product_id,
                 product_url: product_url,
                 sku:         sku,
               },
               success: function(response_data) {
                 response_data = JSON.parse(response_data);
                 if (response_data.success !== undefined &&
                     response_data.success) {
                   if (response_data.removed) {
                     if ($this.find('.fa-trash').length > 0) {
                       $this.closest('.product-block').remove();
                       if ($body.find('#items-container .product-block').length == 0) {
                         $body.find('#no-items-container').show();
                       }
                     } else {
                       $this.find('.wishlist-selected').
                             addClass('wishlist-hidden');
                       $this.find('.wishlist-unselected').
                             removeClass('wishlist-hidden');
                     }
                   } else {
                     $this.find('.wishlist-unselected').
                           addClass('wishlist-hidden');
                     $this.find('.wishlist-selected').
                           removeClass('wishlist-hidden');
                   }

                   if (response_data.removed != undefined &&
                       response_data.removed == true &&
                       $('#number-items').length > 0) {
                     var count = $('#number-items').find('div').html();
                     count     = parseInt(count) - 1;
                     if (count == 1) {
                       $('#number-items').
                           html('<div style=\'padding:16px 0;\'>' + count +
                                ' item</div>');
                     } else {
                       $('#number-items').
                           html('<div style=\'padding:16px 0;\'>' + count +
                                ' items</div>');
                     }
                   }
                   // updateCount();
                 }
               },
               error:   function(response_data) {
                 console.log(response_data);
               },
             });
    }

  });

  setTimeout(function() {
    getWishlistItems();
    // updateCount();
  }, 500);

//   let wishlist_mouse_over = false;
//   $body.on('mouseover', '.wishlist-item', function(){
//     if(!wishlist_mouse_over){
//       $(this).find('.wishlist-unselected').hasClass('wishlist-hidden')
//       ? $(this).find('.wishlist-unselected').removeClass('wishlist-hidden')
//       : $(this).find('.wishlist-unselected').addClass('wishlist-hidden');

//       $(this).find('.wishlist-selected').hasClass('wishlist-hidden')
//       ? $(this).find('.wishlist-selected').removeClass('wishlist-hidden')
//       : $(this).find('.wishlist-selected').addClass('wishlist-hidden');
//       wishlist_mouse_over = true;
//     }

//   });
//   $body.on('mouseleave', '.wishlist-item', function(){
//     if(wishlist_mouse_over){
//       $(this).find('.wishlist-unselected').hasClass('wishlist-hidden')
//       ? $(this).find('.wishlist-unselected').removeClass('wishlist-hidden')
//       : $(this).find('.wishlist-unselected').addClass('wishlist-hidden');

//       $(this).find('.wishlist-selected').hasClass('wishlist-hidden')
//       ? $(this).find('.wishlist-selected').removeClass('wishlist-hidden')
//       : $(this).find('.wishlist-selected').addClass('wishlist-hidden');
//       wishlist_mouse_over = false;
//     }

//   });

  /*end.wishlist*/

  // setTimeout(function() {
  //     $body.html(removeLangText(window.theme_data.locale , $body.html()));
  //     $body.html($body.html().split('--' + window.theme_data.locale + '--').join(''));
  // }, 1000);
  // processElements('.footer__text');
});

function updateCount() {
  let $body = $('body');
  $.ajax({
           url:     'https://app.everydaysunday.com/api/wishlist',
           method:  'POST',
           data:    {
             action: 'get-items-count',
             email:  window.theme_data.customer_email,
             lang:   window.theme_data.locale,
           },
           success: function(response_data) {
             response_data = JSON.parse(response_data);
             if (response_data.success !== undefined && response_data.success) {
               $body.find('.wishlist-count').each(function() {
                 $(this).text(response_data.count);
                 $(this).show();
               });
             }
           },
           error:   function(response_data) {
             console.log(response_data);
           },
         });
}

function getWishlistItems() {
  let $body = $('body');
  let skus  = '';
  $body.find('.wishlist-item').each(function() {
    let pContainer = $(this);
    let sku        = pContainer.attr('data-sku');
    skus += sku + ',';

  });
  $.ajax({
           url:     'https://app.everydaysunday.com/api/wishlist',
           method:  'POST',
           data:    {
             action: 'check-items',
             email:  window.theme_data.customer_email,
             skus:   skus,
           },
           success: function(response_data) {
             response_data = JSON.parse(response_data);
             if (response_data.success !== undefined && response_data.success) {
               $body.find('.wishlist-item').each(function() {
                 let pContainer = $(this);
                 let sku        = pContainer.attr('data-sku');
                 if ($(this).find('.fa-trash').length == 0) {
                   if (response_data.skus.indexOf(sku) == (-1)) {
                     pContainer.find('.wishlist-selected').
                                addClass('wishlist-hidden');
                     pContainer.find('.wishlist-unselected').
                                removeClass('wishlist-hidden');
                   } else {
                     pContainer.find('.wishlist-unselected').
                                addClass('wishlist-hidden');
                     pContainer.find('.wishlist-selected').
                                removeClass('wishlist-hidden');
                   }
                 }
               });
             }
           },
           error:   function(response_data) {
             console.log(response_data);
           },
         });
}

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function removeLangText(lang, text) {
  // This regex matches '--en--' then any characters (non-greedy) until the next '--en--', including it
  if (lang == 'fr') {
    var regex = /--en--.*?--en--/gs;
  } else {
    var regex = /--fr--.*?--fr--/gs;
  }
  return text.replace(regex, '');
}

function processElements(element) {
  let remove_lang = window.theme_data.locale == 'fr' ? 'en' : 'fr';
  let regex       = '';
  if (remove_lang === 'fr') {
    regex = /--fr--.*?--fr--/gs;
  } else {
    regex = /--en--.*?--en--/gs;
  }
  // Now, go through all the children of the current element
  $(element).children().each(function() {
    if ($(this).html().includes(remove_lang)) {
      $(this).html($(this).html().replace(regex, ''));
      $(this).html($(this).html().split('--' + window.theme_data.locale + '--').join(''));
    }
    processElements(this); // Recursive call for each child
  });
}

